import { useContext, useEffect, useState } from 'react';
import { TimerContext } from '../context/TimerContext';
import { formatMillisecondsToTime } from '../../../utils/formatTime';

function RunningTime({ open = true }) {
  const { isRunning, todayTime = 0, startTime, setLoading } = useContext(TimerContext);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    let intervalFn;
    if (isRunning) {
      intervalFn = setInterval(() => {
        const runningTimer = Date.now() - new Date(startTime).getTime();
        const totalTimer = runningTimer + todayTime;
        setTimer(formatMillisecondsToTime(totalTimer));
        setLoading(false);
      }, 1000);
    } else {
      clearInterval(intervalFn);
      setTimer(formatMillisecondsToTime(todayTime));
    }

    return () => {
      clearInterval(intervalFn);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRunning, todayTime]);

  if (!open) return '00:00:00';

  return timer ?? '00:00:00';
}

export default RunningTime;
